import { render, staticRenderFns } from "./ContentDetail.vue?vue&type=template&id=937e4080&scoped=true&"
import script from "./ContentDetail.vue?vue&type=script&lang=js&"
export * from "./ContentDetail.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetail.vue?vue&type=style&index=0&id=937e4080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937e4080",
  null
  
)

export default component.exports